import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './StaffModal.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    padding: '20px'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  }
};

Modal.setAppElement('#root');

function StaffModal({ isOpen, onClose, onSubmit, initialData, role }) {
  const [formData, setFormData] = useState({ ...initialData });
  const [showDirectDepartmentInput, setShowDirectDepartmentInput] = useState(false);

  const departmentOptions = ["감리", "총무", "재무"];

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
      if (initialData.department && !departmentOptions.includes(initialData.department)) {
        setShowDirectDepartmentInput(true);
      }
    } else {
      setFormData({ name: '', position: '', phone: '', department: '', role: role });
      setShowDirectDepartmentInput(false);
    }
  }, [initialData, role, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phone') {
      const cleaned = ('' + value).replace(/\D/g, '');
      let match = cleaned.match(/^(02|010|\d{3})(\d{3,4})(\d{4})$/);
      let formattedPhone = value;
      if(match) {
        formattedPhone = [match[1], match[2], match[3]].join('-');
      } else {
        // As-you-type formatting
        let formatted = cleaned;
        if (cleaned.startsWith('02') && cleaned.length > 2) {
          formatted = cleaned.substring(0, 2) + '-' + cleaned.substring(2);
          if (cleaned.length > 6) {
            formatted = formatted.substring(0, 7) + '-' + formatted.substring(7, 11);
          }
        } else if (!cleaned.startsWith('02') && cleaned.length > 3) {
          formatted = cleaned.substring(0, 3) + '-' + cleaned.substring(3);
          if (cleaned.length > 7) {
            formatted = formatted.substring(0, 8) + '-' + formatted.substring(8, 12);
          }
        }
        formattedPhone = formatted;
      }
      setFormData(prev => ({ ...prev, [name]: formattedPhone }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleDepartmentChange = (e) => {
    const { value } = e.target;
    if (value === 'direct') {
      setShowDirectDepartmentInput(true);
      setFormData(prev => ({ ...prev, department: '' }));
    } else {
      setShowDirectDepartmentInput(false);
      setFormData(prev => ({ ...prev, department: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles}>
      <div className="staff-modal-header">
        <h2>{initialData ? '직원 수정' : '직원 추가'}</h2>
      </div>
      <form onSubmit={handleSubmit} className="staff-modal-form">
        <div className="form-group">
          <label>이름</label>
          <input type="text" name="name" value={formData.name || ''} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label>직책</label>
          <select name="position" value={formData.position || ''} onChange={handleChange} required>
            <option value="">직책 선택</option>
            <option value="대표이사">대표이사</option>
            <option value="전무이사">전무이사</option>
            <option value="상무이사">상무이사</option>
            <option value="부장">부장</option>
            <option value="과장">과장</option>
            <option value="대리">대리</option>
            <option value="사원">사원</option>
          </select>
        </div>
        <div className="form-group">
          <label>전화번호</label>
          <input type="text" name="phone" value={formData.phone || ''} onChange={handleChange} />
        </div>
        {formData.role !== 'CEO' && (
          <div className="form-group">
            <label>소속</label>
            <select onChange={handleDepartmentChange} value={showDirectDepartmentInput ? 'direct' : formData.department || ''}>
              <option value="">부서 선택</option>
              {departmentOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              <option value="direct">직접입력</option>
            </select>
            {showDirectDepartmentInput && (
              <input 
                type="text" 
                name="department" 
                value={formData.department || ''} 
                onChange={handleChange} 
                placeholder="부서명 입력"
                style={{ marginTop: '10px' }}
              />
            )}
          </div>
        )}
        <div className="form-group full-width">
          <label>역할</label>
          <select name="role" value={formData.role || ''} onChange={handleChange} required>
            <option value="">역할 선택</option>
            <option value="CEO">대표이사</option>
            <option value="EXECUTIVE">임원</option>
            <option value="EMPLOYEE">직원</option>
          </select>
        </div>
        <div className="staff-modal-footer">
          <button type="submit" className="submit-btn">{initialData ? '수정' : '추가'}</button>
          <button type="button" onClick={onClose} className="cancel-btn">취소</button>
        </div>
      </form>
    </Modal>
  );
}

export default StaffModal;
